import { Flex, Spin, Typography } from "antd";
import { FullPageContentContainer } from "@vyne-shared/components/vyneNavigation/PageContentContainers";
import { PaymentsLandingLoading } from "./paymentsLandingLoading/PaymentsLandingLoading";

const { Title } = Typography;

export interface PageLoadingProps {
    readonly type?: "Spin" | "PaymentsLanding";
    readonly children: React.ReactNode;
}

export const PageLoading = (props: PageLoadingProps) => {
    const loadingProps = { ...props };

    loadingProps.children = <LoadingPrompt>{props.children}</LoadingPrompt>;

    return (
        <FullPageContentContainer className="vyne-payments-landing navigation-loading">
            {props.type === "PaymentsLanding" ? (
                <PaymentsLandingLoading {...loadingProps} />
            ) : (
                <SpinLoading {...loadingProps} />
            )}
        </FullPageContentContainer>
    );
};

const LoadingPrompt = ({ children }: PageLoadingProps) => (
    <p className="navigation-loading-prompt" style={{ marginTop: "1rem" }}>
        {children}
    </p>
);

export const SpinLoading = ({ children }: PageLoadingProps) => (
    <Flex align="center" justify="center" vertical={true} style={{ margin: "2rem" }}>
        <Spin size="large" delay={2000} />
        <Title level={2}>{children}</Title>
    </Flex>
);
